
export enum EquipmentQualifierCd {
	EMPTY = 'Empty',
	HEADLOAD = 'Headload',
	LOADED = 'Loaded'}

